import { Row } from '@/components/layout/layout'
import React, { useState } from 'react'
import { createUseStyles } from 'react-jss'

import { Select } from 'formik-antd'

const useStyles = createUseStyles({
    inputContainer: {
        height: '50px',
        borderBottom: '1px solid rgba(0,0,0,0.10)',

        '& .ant-select': {
            flex: 1,
        },

        '& .ant-select-selection-search': {
            left: '0 !important',
        },

        '& .ant-select-selection-placeholder': {
            color: '#999',
        },

        '& .ant-select-selector': {
            padding: '0 !important',
            border: 'none !important',
            outline: 'none !important',
            boxShadow: 'none !important',
        },

        '& .ant-select-arrow': {
            display: 'none',
        },
    },

    onFocus: {
        borderBottom: '1px solid #14CC9B',
    },
})

const Input: React.FC<
    {
        placeholder?: string
        inputprefix?: () => React.ReactNode
        inputsuffix?: () => React.ReactNode
        wrapClassName?: string
        reg?: RegExp
        onFocus?: () => void
        onBlur?: () => void
    } & any
> = props => {
    const styles = useStyles()
    const [isFocus, setFocusStatus] = useState(false)

    const onFocus = () => {
        props.onFocus && props.onFocus()
        setFocusStatus(true)
    }

    const onBlur = () => {
        props.onBlur && props.onBlur()
        setFocusStatus(false)
    }

    const { reg, error, wrapClassName, inputsuffix, inputprefix, ...reset } = props

    return (
        <Row
            data-expaned
            data-align-items-center
            className={[styles.inputContainer, isFocus ? styles.onFocus : '', props.wrapClassName].join(' ')}
        >
            {props.inputprefix && props.inputprefix()}
            <Select
                filterOption={(input, option) => option?.children.indexOf(input.trim()) >= 0}
                {...reset}
                onFocus={onFocus}
                onBlur={onBlur}
            >
                {props.children}
            </Select>
            {props.inputsuffix && props.inputsuffix()}
        </Row>
    )
}

export default Input
